<template>
	<div class="payment-product-info-table">
		<div class="header">
			<div class="title">상품정보</div>
		</div>
		<div class="content">
			<table class="product-info-table">
				<thead>
					<tr>
						<th style="width: 650px"><span>상품 정보</span></th>
						<th style="width: 80px"><span>수량</span></th>
						<th style="width: 110px"><span>판매가</span></th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>
							<div class="info">
								<payment-product-info ref="payment-product-info" :product="requestProduct.product"></payment-product-info>
								<div class="type-badge">구매대행</div>
							</div>
						</td>
						<td>
							<div>
								{{ requestProduct.quantity }}
							</div>
						</td>
						<td>
							<div class="selling-price">{{ CommaNum(requestProduct.price) }}원</div>
						</td>
					</tr>
				</tbody>
			</table>
			<TotalPrice :orderTotal="orderTotal" />
		</div>
	</div>
</template>

<script>
import PaymentProductInfo from '@/views/payment/components/PaymentProductInfo.vue'
import TotalPrice from './TotalPrice.vue'
import mixin from '@/mixins'
import { mapGetters } from 'vuex'

export default {
	name: 'ProductInfoTable',
	props: {
		requestProduct: {
			type: Object,
		},
	},
	components: {
		PaymentProductInfo,
		TotalPrice,
	},
	computed: {
		...mapGetters('user', ['instituteId']),
	},
	data() {
		return {
			orderTotal: {
				totalPrice: 0,
				totalDiscountPrice: 0,
				totalVat: 0,
				totalSellingPriceWithVat: 0,
			},
		}
	},
	mixins: [mixin],
	mounted() {
		this.orderTotal = {
			totalPrice: this.requestProduct.price,
			totalDiscountPrice: 0,
			totalVat: this.requestProduct.vat,
			totalSellingPriceWithVat: this.requestProduct.priceWithVat,
		}
	},
}
</script>

<style lang="scss" scoped>
.payment-product-info-table {
	.header {
		.title {
			font-weight: bold;
			font-size: 1.25rem;
		}
	}
	.content {
		max-height: calc(60px + 750px + 90px);
		overflow-y: auto;
		margin-top: 10px;
		border: 1px solid $COLOR_DDD;
		border-radius: 5px;
		.product-info-table {
			width: 100%;
			thead {
				height: 60px;
				background: $LIST_BACKGROUND;
				border-radius: 5px;
				position: sticky;
				top: 0;
				z-index: 1;
				tr {
					th {
						background-color: $LIST_BACKGROUND;
						text-align: center;
						font-size: 0.875rem;
						&:first-child {
							padding-left: 20px;
							text-align: left;
						}
					}
				}
			}
			tbody {
				border-top: 1px solid $COLOR_DDD;
				border-bottom: 1px solid $COLOR_DDD;
				tr {
					height: 150px;
					&:not(:last-child) {
						border-bottom: 1px solid $COLOR_DDD;
					}
					td {
						.info {
							display: flex;
							align-items: center;
							justify-content: space-between;
							& > *:first-child {
								min-width: 90%;
							}
							& > * {
								flex-grow: 0;
							}
							.type-badge {
								font-size: 12px;
								color: #ff8a00;
								background-color: #fff3d6;
								border-radius: 5px;
								padding: 2px 5px;
								word-break: keep-all;
							}
						}
						&:first-child div {
							padding: 10px;
						}
						&:not(:first-child) div {
							display: flex;
							justify-content: center;
							align-items: center;
						}

						.selling-price {
							font-weight: 700;
						}
						.price {
							text-decoration: line-through;
							font-size: 0.875rem;
							color: $FONT_PLACEHOLDER;
						}
						.sale-percent {
							margin-top: 4px;
							font-size: 12px;
							font-weight: 700;
							padding: 2px 6px;
							border-radius: 4px;
							background-color: #ff3b31;
							color: white;
						}
					}
					td + td {
						border-left: 1px solid $COLOR_DDD;
					}
				}
			}
		}
		.cart-product-total-price {
			position: sticky;
			bottom: 0;
		}
	}
}
</style>
